import {IntermediatePart} from "../parts/intermediatePart";

export default class Shadow extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'part_shadow';
    this.visible = false;
    this.partName = 'Part Shadow';
  }
  load(dbFeature) {
    return super.load_(dbFeature, new Shadow());
  }
}